// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "6201ff5ee7ea0cfb03ac" + ".js";
};